import { z } from "zod";

export const askGspQuerySchema = z.object({
  question: z.string().min(1).max(500),
});
export type AskGspQueryInput = z.infer<typeof askGspQuerySchema>;

export interface AskGspAnswer {
  answer: string;
  sources: string[];
}
